<form nz-form se-container="1" [formGroup]="form" nzLayout="horizontal" labelWidth="150">
  <se-title>FROM</se-title>
  <nz-divider class="m-sm"></nz-divider>
  <se label="Account Number" required [error]="'Account Number is required.'">
    <nz-input-group [nzAddOnAfter]="accountCurrency" class="width-100">
      <nz-select formControlName="account" class="width-100" [nzCustomTemplate]="displayTpl" nzShowSearch="true"
        autocomplete="off">
        <ng-template #displayTpl let-selected>
          {{ selected.nzLabel }}
        </ng-template>
        <ng-container *ngFor="let o of bankAccs">
          <nz-option [nzValue]="o.bankAccountNo" [nzLabel]="o.bankAccountNo" nzCustomContent>
            <div>
              <strong>{{ o.bankAccountNo }}</strong>
              <nz-tag class="ml-sm">
                {{ o.currencyCode }}
              </nz-tag>
            </div>
            <div class="text-grey-dark">
              <span>{{ o.code }}</span>:
              <span> {{ o.name }}</span>
            </div>
          </nz-option>
        </ng-container>
      </nz-select>
      <ng-template #accountCurrency>
        <span class="min-width-xs">
          {{form.controls.accountCurrency.value}}
        </span>
      </ng-template>
    </nz-input-group>
  </se>

  <se-title>TO</se-title>
  <nz-divider class="m-sm"></nz-divider>
  <se label="Bank Name" required="required" error="Bank Name is required.">
    <nz-select formControlName="payeeBankName" [nzOptions]="bankOptions" nzShowSearch="true" autocomplete="off"></nz-select>
  </se>
  <se label="Bank Code" required="required" error="Bank Code is required.">
    <input nz-input formControlName="payeeBankBIC" />
  </se>
  <se label="Payee Account" required="required" error="Payee Account is required.">
    <input nz-input formControlName="payeeAccount" maxlength="19" app-digit-only />
  </se>
  <se label="Resident Status" required>
    <nz-radio-group formControlName="isResident">
      <label nz-radio [nzValue]="true">Resident</label>
      <label nz-radio [nzValue]="false">Non-Resident</label>
    </nz-radio-group>
  </se>

  <se-title>AMOUNT & WHEN</se-title>
  <nz-divider class="m-sm"></nz-divider>
  <se label="Transaction Date" required [error]="'Transaction Date is required.'">
    <nz-date-picker formControlName="transferDate" [nzDisabledDate]="disabledDate"></nz-date-picker>
  </se>
  <se label="Amount" required="required" error="Transaction Amount is required."
    [optional]="'(' + form.controls.currency.value + ')'">
    <app-currency-input formControlName="amount"></app-currency-input>
  </se>
  <se label="Reference No." required [error]="'Reference No. is required.'">
    <input nz-input formControlName="payeeRef" maxlength="35" />
  </se>
</form>
